<template>
    <div>
        <el-form :model="receipt" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">服务商</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="sellerName">
                            <el-input class="width-1-5x bottom-line" disabled type="text" v-model="receipt.sellerName"></el-input>
                            <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectServicer()"></div>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">是否常规服务</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="comnSvcFlag">
                            <el-radio-group v-model="comnSvcFlag" @change="setComnSvcFlag()">
                                <el-radio class="radio mr10" :label="true">是</el-radio>
                                <el-radio class="radio" :label="false">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="content-caption dashed">
            <span>工单信息</span>
            <a class="swb-btn swb-btn-small" @click="selectWorkVoucher()">选择工单</a>
            <span class="input-tip error" style="font-size: 12px;" v-if="!receiptAllowed">提示:常规服务工单无法合并验收，会单独生成验收单</span>
        </div>
        <div class="table-layout">
            <div v-if="workVoucherList != null && workVoucherList.length > 0">
                <div class="simple-row">
                    <div class="right">
                        <span v-if="workVoucherList != null">已选择({{ workVoucherList.length }})</span>
                    </div>
                </div>
                <el-table ref="multipleTable" :data="workVoucherList" border tooltip-effect="dark" maxHeight="400" style="width: 100%">
                    <el-table-column align="center" prop="no" label="工单号" width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="servcType" label="工单类型" align="center">
                        <template slot-scope="rows">
                            <span>{{ servcTypeMap[rows.row.servcType] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="contractNo" label="系统合同编号" width="140" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="devcGroupFullName" label="维保分组" width="140" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="buyerShopFullName" label="部门全称" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="creatorName" label="创建人" width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="servicerName" label="服务商" width="240"></el-table-column>
                    <el-table-column prop="toDoorFee" align="right" width="100" label="上门费(元)">
                        <template slot-scope="rows">
                            <span>{{ (rows.row.toDoorFee || 0).toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="generallFee" align="right" width="100" label="服务费(元)">
                        <template slot-scope="rows">
                            <span>{{ (rows.row.generallFee || 0).toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="accFee" align="right" width="100" label="配件费(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.accFee != null">{{ rows.row.accFee.toFixed(2) }}</span>
                            <span v-else>0.00</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="examineTime" label="确认完成时间" width="140"></el-table-column>
                    <el-table-column align="center" width="100" label="操作" fixed="right">
                        <template slot-scope="rows">
                            <a class="swb-btn-link" @click="removeVoucher(rows.$index)">移除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {MsgBox} from '../../app.vues'
    import {selectRealAdoptedComDlg} from '../realCom/dialog';
    import {openServcWorkVoucherListForSelectDlg} from '../workVoucher/showDetailDlg';

    import servicerApi from '../../api/servicer';
    import userApi from '../../api/user';
    import merchtComnApi from '../../api/merchtComn';
    import {getMerchantBizParam} from '../asset/assetMain';

    export default {
        name: 'swb-servc-work-receipt-save',
        desc: '工单验收保存',
        props: {},
        data: function () {
            let checkNull = function (rule, value, callback) {
                if (Utils.isNoB(value) && Utils.isFalse(this.buildFlag)) {
                    callback(new Error('不能为空'));
                } else {
                    callback();
                }
            };
            return {
                receipt: {},
                workVoucherList: [],
                scopeEntity: {},
                servcTypeMap: getEnumMap('servcType', 'value2text'),
                receiptAllowed: true,
                rules: {
                    sellerName: [{validator: checkNull, trigger: 'change'}]
                },
                comnSvcFlag: true
            }
        },
        created: function () {
            let self = this;
            this.getCurrentUserInfo();
            //
            getMerchantBizParam('comn.svc.work.voucher.merge.receipt.allowed', function (result) {
                self.receiptAllowed = Utils.isTrue(result);
            }, 0);
        },
        methods: {
            // 获取用户信息
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if (result.type === 'info') {
                        let user = result.data;
                        //
                        self.scopeEntity = Utils.merge({}, user.scopeEntity);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选择而服务商
            selectServicer: function () {
                let self = this;
                let peerMerchantType = getEnumInfoWith('merchantType', 'name', 'Servicer').value;
                // 选择入选服务公司
                selectRealAdoptedComDlg({
                    checkBox: false,
                    filter: {
                        peerMerchantType: peerMerchantType
                    }
                }, function (realAdoptedCom, theDlg) {
                    theDlg.close();
                    realAdoptedCom = realAdoptedCom || {};
                    self.getServicer(realAdoptedCom.peerRealMerchantId, realAdoptedCom.peerRealComId, function (servicer) {
                        let receipt = self.receipt || {};
                        if (receipt.sellerId != servicer.id) {
                            self.workVoucherList = [];
                        }
                        receipt.sellerId = servicer.id;
                        receipt.sellerName = servicer.name;
                        receipt.sellerType = realAdoptedCom.peerMerchantType;
                        receipt.sellerRealId = realAdoptedCom.peerRealMerchantId;
                        receipt.sellerRealComId = realAdoptedCom.peerRealComId;
                        receipt.sellerRealComName = realAdoptedCom.peerRealComName;
                        self.receipt = Utils.merge({}, receipt);
                    });
                });
            },
            // 获取服务商户信息
            getServicer(realId, realComId, callback) {
                let postData = {};
                postData.pagination = {
                    pageSize: 1,
                    pageNumber: 1,
                };
                let filterItems = {};
                filterItems.realId = realId;
                filterItems.realComId = realComId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = [];
                postData.sortItems = {};
                //
                let theLoad = MsgBox.loading();
                servicerApi.getMerchantDtoList(postData, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        let rows = result.data.rows;
                        if (Utils.isNoB(rows) || rows.length == 0) {
                            MsgBox.warning('无法获取供应商');
                        } else {
                            callback(rows[0]);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选择工单
            selectWorkVoucher: function () {
                let self = this;
                let receipt = self.receipt || {};
                if (Utils.isNoB(receipt.sellerId)) {
                    MsgBox.warning('请选择服务商');
                    return;
                }
                let workVoucherList = self.workVoucherList || [];
                let checkedIds = workVoucherList.pluck('id') || [];
                let params = {
                    checkBox: true,
                    checkedIds: checkedIds,
                    filter: {
                        buyerId: self.scopeEntity.id,
                        buyerShopId: self.scopeEntity.bizUnitLevel != 1 ? self.scopeEntity.bizUnitId : null,
                        queryAllCurrMercht: self.scopeEntity.bizUnitLevel != 1 ? false : true,
                        servicerId: receipt.sellerId,
                        accepted: true, // 已服务验收未工单验收
                        workReceiptId: -1,
                        workReceipConfirmFlag: false,
                        contractFlag: true,
                        comnSvcFlag: self.comnSvcFlag,
                        olPaid: false
                    }
                };
                openServcWorkVoucherListForSelectDlg(params, function (workVoucherList, theDlg) {
                    let srcWorkVoucherList = self.workVoucherList || [];
                    let checkedIds = srcWorkVoucherList.pluck('id');
                    //
                    let allIds = workVoucherList.pluck('id');
                    // 移除的
                    let lessIds = Utils.compareArrays(allIds, checkedIds)['less'];
                    for (let i = 0; i < srcWorkVoucherList.length; i++) {
                        let voucherInfo = srcWorkVoucherList[i];
                        if (lessIds.indexOf(voucherInfo.id) >= 0) {
                            srcWorkVoucherList.splice(i, 1);
                            i--;
                        }
                    }
                    // 新增的
                    let moreIds = Utils.compareArrays(allIds, checkedIds)['more'];
                    let workVoucherMaps = workVoucherList.toMap('id');

                    for (let i = 0; i < moreIds.length; i++) {
                        let moreId = moreIds[i];
                        //
                        let voucherInfo = workVoucherMaps[moreId];
                        srcWorkVoucherList.push(voucherInfo);
                    }
                    //
                    self.workVoucherList = Utils.merge([], srcWorkVoucherList);
                    theDlg.close();
                });
            },
            // 移除工单
            removeVoucher: function (index) {
                let workVoucherList = this.workVoucherList || [];
                workVoucherList.splice(index, 1);
                this.workVoucherList = Utils.merge([], workVoucherList);
            },
            setComnSvcFlag() {
                this.workVoucherList = Utils.merge([], []);
            },
            getDlgResult: function () {
                let result = {};
                let receipt = this.receipt || {};
                let workVoucherList = this.workVoucherList || [];
                if (Utils.isNoB(receipt.sellerId)) {
                    result.type = 'warn';
                    result.message = '请选择服务商！';
                } else if (workVoucherList.length <= 0) {
                    result.type = 'warn';
                    result.message = '请选择工单！';
                } else {
                    receipt.workVoucherList = Utils.merge([], workVoucherList);
                    //
                    result.type = 'info';
                    result.data = Utils.merge({}, receipt);
                }
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/receipt/ServcWorkReceiptSave.vue